<template>
  <v-dialog v-model="show2" content-class="dialog-fixed-size dialog-small"
    @keydown.esc.stop="closeDialog"
    @keydown.enter.stop="step === maxStep && validateForm()">
    <v-card>
      <v-card-title class="secondary--text">
        <h1>
          {{ stepTitle }}
        </h1>
        <v-spacer></v-spacer>
        <v-icon dark x-large color="secondary">{{ stepTitleIcon }}</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form1" v-show="step === 1">
          <div class="l-row">
            <v-text-field name="newFirstName" id="newFirstName" required
              :label="$t('LBL.FIRST_NAME')"
              v-model="newFirstName" :rules="firstNameRules"
            ></v-text-field>

            <v-text-field name="newLastName" id="newLastName" required
              :label="$t('LBL.FAMILY_NAME')"
              v-model="newLastName" :rules="lastNameRules"
            ></v-text-field>
          </div>
        </v-form>
        <v-form ref="form2" v-show="step === 2">
          <div class="l-row">
            <v-text-field name="newEmail" id="newEmail" required
              autocomplete="email"
              :label="$t('LBL.EMAIL')"
              v-model="newEmail" :rules="emailRules"
            ></v-text-field>

            <v-text-field name="newRepeatEmail" id="newRepeatEmail" required
              autocomplete="email"
              :label="$t('LBL.REPEAT_EMAIL')"
              v-model="newRepeatEmail" :rules="repeatEmailRules"
            ></v-text-field>
          </div>
        </v-form>
        <v-form ref="form3" v-show="step === 3">
          <div class="l-row">
            <div hidden>
              <v-text-field name="username" required
                autocomplete="username" id="username"
                v-model="newEmail"
              ></v-text-field>
            </div>

            <v-text-field type="password" name="newPassword" required
              autocomplete="new-password"
              id="newPassword" :label="$t('LBL.PASSWORD')"
              v-model="newPassword" :rules="passwordRules"
            ></v-text-field>

            <v-text-field type="password" name="newRepeatPassword" required
              autocomplete="new-password"
              id="newRepeatPassword" :label="$t('LBL.REPEAT_PASSWORD')"
              v-model="newRepeatPassword" :rules="repeatPasswordRules"
            ></v-text-field>
          </div>
        </v-form>
        <v-form ref="form4" v-show="step === 4">
          <div class="l-row">
            <v-checkbox
              class="checkbox-long-label"
              v-model="readPrivacyStmt"
              required
              :rules="readPrivacyStmtRules"
            >
              <span slot="label" v-html="$t('TXT.REGISTER_DIALOG_LBL_READ_PRIVACY_STMT_HTML')" @click="inputLabelClicked($event)"></span>
            </v-checkbox>
            <v-checkbox
              class="checkbox-long-label"
              v-model="readTOC"
              required
              :rules="readTOCRules"
            >
              <span slot="label" v-html="$t('TXT.REGISTER_DIALOG_LBL_READ_TOC_HTML')" @click="inputLabelClicked($event)"></span>
            </v-checkbox>
            <v-checkbox
              class="checkbox-long-label"
              v-model="ackReceiveEmail"
              required
              :rules="ackReceiveEmailRules"
            >
              <span slot="label" v-html="$t('TXT.REGISTER_DIALOG_LBL_ACK_RECEIVE_EMAIL_HTML')" @click="inputLabelClicked($event)"></span>
            </v-checkbox>
            <v-checkbox
              class="checkbox-long-label"
              v-model="agreeDataCollection"
              required
              :rules="agreeDataCollectionRules"
            >
              <span slot="label" v-html="$t('TXT.REGISTER_DIALOG_LBL_AGREE_DATA_COLLECTION_HTML')" @click="inputLabelClicked($event)"></span>
            </v-checkbox>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="primary">
        <v-btn flat dark @click.stop="closeDialog('login')" :disabled="loading">{{ $t('LBL.LOG_IN') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat dark v-show="step === 1" @click.stop="closeDialog">{{ $t('LBL.CANCEL') }}</v-btn>
        <v-btn flat dark v-show="step > 1" @click.stop="prevStep" :disabled="loading">{{ $t('LBL.BACK') }}</v-btn>
        <v-btn flat dark v-show="step < maxStep" @click.stop="validateAndNextStep">{{ $t('LBL.NEXT') }}</v-btn>
        <v-btn flat dark v-show="step === maxStep" @click.stop="validateForm"
          :loading="loading" :disabled="loading">{{ $t('LBL.REGISTER') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { ENQUEUE_SNACKBAR } from '@/store/mutation-types'
import ServerErrorMixin from '@/components/mixins/ServerErrorMixin'

export default {
  name: 'RegisterDialog',
  computed: {
    stepTitle () {
      const titleText = [
        '',
        'LBL.YOUR_DETAILS',
        'LBL.YOUR_EMAIL_ADDRESS',
        'LBL.YOUR_PASSWORD',
        'LBL.AGREE'
      ][this.step]

      return titleText ? this.$i18n.t(titleText) : ''
    },
    stepTitleIcon: function () {
      return [
        '',
        'face',
        'email',
        'lock_outline',
        'info_outline'
      ][this.step]
    },
    ...mapGetters([
      'userLanguage'
    ])
  },
  data () {
    return {
      show2: false,
      animating: false,
      loading: false,
      step: 1,
      maxStep: 4,
      firstNameRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.FIRST_NAME')})
      ],
      lastNameRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.FAMILY_NAME')})
      ],
      emailRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.EMAIL')}),
        v => /^\w+([.-]?\w+)*([+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('RULE.FIELD_INVALID_VALUE', {FIELD: this.$i18n.t('LBL.EMAIL')})
      ],
      passwordRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.PASSWORD')}),
        v => (!!v && v.length >= 4) || this.$i18n.t('RULE.FIELD_MIN_LENGTH', {FIELD: this.$i18n.t('LBL.PASSWORD'), FIELD_LEN: '4 ' + this.$i18n.t('LBL.CHARACTERS')})
      ],
      repeatEmailRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.REPEAT_EMAIL')}),
        v => v === this.newEmail || this.$i18n.t('RULE.FIELD_VALUE_MISMATCH', {FIELD: this.$i18n.t('LBL.REPEAT_EMAIL')})
      ],
      repeatPasswordRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.REPEAT_PASSWORD')}),
        v => v === this.newPassword || this.$i18n.t('RULE.FIELD_VALUE_MISMATCH', {FIELD: this.$i18n.t('LBL.REPEAT_PASSWORD')})
      ],
      readPrivacyStmtRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.MSG_THIS_FIELD')})
      ],
      readTOCRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.MSG_THIS_FIELD')})
      ],
      ackReceiveEmailRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.MSG_THIS_FIELD')})
      ],
      agreeDataCollectionRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.MSG_THIS_FIELD')})
      ],
      newFirstName: '',
      newLastName: '',
      newEmail: '',
      newRepeatEmail: '',
      newPassword: '',
      newRepeatPassword: '',
      readPrivacyStmt: false,
      readTOC: false,
      ackReceiveEmail: false,
      agreeDataCollection: false
    }
  },
  methods: {
    updateStep (nextStep) {
      this.animating = true
      this.show2 = false
      setTimeout(() => {
        this.step = nextStep
        Vue.nextTick(() => {
          this.animating = false
          this.show2 = true
        })
      }, 100)
    },
    validateAndNextStep () {
      const form = this.$refs[`form${this.step}`]
      if (form.validate()) {
        let incStep = 1
        this.updateStep(this.step + incStep)
      }
    },
    prevStep () {
      let decStep = 1
      this.updateStep(this.step - decStep)
    },
    validateForm () {
      if (this.$refs[`form${this.maxStep}`].validate()) {
        const data = {
          firstName: this.newFirstName,
          lastName: this.newLastName,
          email: this.newEmail,
          language: this.userLanguage,
          password: this.newPassword,
          password2: this.newRepeatPassword,
          acceptPrivacyStmt: this.readPrivacyStmt,
          acceptedTOC: this.readTOC,
          acceptedAnonDataRes: this.agreeDataCollection,
          acceptReceiveEmail: this.ackReceiveEmail
        }

        if (this.loading) {
          return
        }

        this.loading = true

        this.doCreate(data)
          .then(() => {
            this.showMessage({
              text: this.$i18n.t('MSG.REGISTER_SUCCESS'),
              color: 'success'
            })
            this.closeDialog()
          })
          .catch((error) => {
            console.log('error', error, this.getErrorMessage)
            this.showMessage({
              text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
              color: 'error'
            })
          })
          .finally(() => { this.loading = false })
      }
    },
    closeDialog (action) {
      if (action === 'login') {
        this.$emit('click-login')
      }
      this.show2 = false
    },
    inputLabelClicked (event) {
      if (event.target !== event.currentTarget) {
        return event.stopPropagation()
      }
    },
    ...mapActions({
      doCreate: 'createUser'
    }),
    ...mapMutations({
      showMessage: ENQUEUE_SNACKBAR
    })
  },
  mixins: [
    ServerErrorMixin
  ],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show (val) {
      this.show2 = val
    },
    show2 (val) {
      if (this.show2 !== this.show) {
        this.$emit('update:show', this.show2)
      }

      if (!val && !this.animating) {
        Vue.nextTick(() => {
          for (let i = this.step; i <= this.maxStep; i++) {
            this.$refs[`form${i}`].reset()
          }

          this.step = 1
        })
      }
    },
    birthdateMenu (val) {
      val && this.$nextTick(() => (this.$refs.birthdatePicker.activePicker = 'YEAR'))
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dialogs/RegisterDialog.vue